import { User, TokenService } from "@lcs/frontend";
import React from "react";
import PanelCustomers from "../components/PanelCustomers";

function PageCustomers() {

  const getUserLocal = (): User | null => {
    var currentUser: User | null = {
      id: 0,
      name: "",
      surname: "",
      language: "",
      roles: []
    }
    try {
      currentUser = TokenService.getUser()
    } catch (error) {

    }
    return currentUser;
  }
  let currentUser: User | null = getUserLocal();


  return (
      <PanelCustomers culture={currentUser ? currentUser.language : "en-US"} />
  );
}

export default PageCustomers;